export default __webpack_public_path__ + "static/cover-b9186dc4d297f30aa57ccd265693d2ff.png";